export enum CultivationType {
  Conventional = 'Conventional',
  Ecological = 'Ecological',
  Agroecological = 'Agroecological'
}
